// copia la password: dice "copiata" solo se la copia è riuscita
  document.getElementById('copia').addEventListener('click', function () {
    var b = this, pw = document.getElementById('pw').textContent;
    var ok = function () { b.textContent = 'Mot de passe copié ✓'; };
    var no = function () { b.textContent = 'Appuyez longuement sur le mot de passe pour le copier'; };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(pw).then(ok, no); else no();
  });
  // messaggio di uscita: elenca cosa è stato spuntato e cosa no
  document.getElementById('uscita').addEventListener('click', function () {
    var NL = String.fromCharCode(10), fatte = [], mancano = [];
    document.querySelectorAll('#lista input').forEach(function (c) { (c.checked ? fatte : mancano).push(c.value); });
    var t = 'Bonjour ! Nous avons quitté Anima Suite.';
    if (fatte.length) t += NL + NL + 'Fait :' + NL + fatte.map(function (x) { return '✓ ' + x; }).join(NL);
    if (mancano.length) t += NL + NL + 'Non coché :' + NL + mancano.map(function (x) { return '– ' + x; }).join(NL);
    t += NL + NL + 'Merci pour tout !';
    this.dataset.testo = t;
  });







  // clip della spa: partono quando sono a schermo, un tocco le ferma o le fa ripartire.
  // Se il telefono chiede meno movimento, restano ferme finché non si toccano.
  (function () {
    var clip = document.querySelectorAll('video.clip');
    if (!clip.length) return;
    var calmo = matchMedia('(prefers-reduced-motion: reduce)').matches;
    clip.forEach(function (v) {
      var tocca = function () { v.fermo = !v.paused; v.paused ? v.play().catch(function () {}) : v.pause(); };
      v.addEventListener('click', tocca);
      v.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tocca(); } });
    });
    if (!('IntersectionObserver' in window)) { if (!calmo) clip.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var oss = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        var v = x.target;
        if (x.isIntersecting && !calmo && !v.fermo) v.play().catch(function () {});
        else if (!x.isIntersecting) v.pause();
      });
    }, {threshold: 0.4});
    clip.forEach(function (v) { oss.observe(v); });
  })();

  // ricerca in tutta la guida
  (function () {
    var norm = function (t) { return ' ' + t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/'/g, ' ').replace(/-/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
    var voci = [];
    document.querySelectorAll('main section[id]').forEach(function (sec) {
      if (sec.id === 'home' || sec.id === 'grazie') return;
      var h = sec.querySelector('h2');
      var titolo = h ? h.innerHTML.replace(/<br\s*\/?>/g, ' ').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim().replace(/\.$/, '') : sec.id;
      var punto = sec.id;
      sec.querySelectorAll('*').forEach(function (el) {
        if (el.id) punto = el.id;
        if (!el.matches('h2, h3, p, li, .label, .nm, .ds, .cred b, .check span')) return;
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (t.length > 2) voci.push({id: punto, sez: sec.id, titolo: titolo, testo: t, n: norm(t)});
      });
    });
    var inp = document.getElementById('cerca'), out = document.getElementById('risultati');
    var esc = function (t) { return t.replace(/[&<>]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;'}[c]; }); };
    inp.addEventListener('input', function () {
      var q = norm(inp.value).trim();
      if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
      var visti = {}, html = '', tot = 0;
      voci.forEach(function (v) {
        var i = v.n.indexOf(' ' + q);
        if (i < 0 || (visti[v.sez] || 0) >= 2 || tot >= 6) return;
        visti[v.sez] = (visti[v.sez] || 0) + 1; tot++;
        var pezzo = esc(v.testo.length > 110 ? v.testo.slice(0, 110) + '…' : v.testo);
        html += '<a href="#' + v.id + '"><b>' + esc(v.titolo) + '</b><span>' + pezzo + '</span></a>';
      });
      out.innerHTML = html || '<p class="vuoto">Rien trouvé. Essayez un autre mot.</p>';
      out.hidden = false;
    });
  })();



  // meteo di Procida: MET Norway (api.met.no), gratis anche per uso commerciale con citazione della fonte (CC BY 4.0).
  // Se non c'è rete, il riquadro resta senza meteo.
  (function () {
    var desc = function (c) {
      c = (c || '').replace(/_(day|night|polartwilight)$/, '');
      if (c === 'clearsky') return 'ciel dégagé';
      if (c === 'fair' || c === 'partlycloudy') return 'peu nuageux';
      if (c === 'cloudy') return 'nuageux';
      if (c === 'fog') return 'brouillard';
      if (c.indexOf('thunder') >= 0) return 'orage';
      if (c.indexOf('snow') >= 0 || c.indexOf('sleet') >= 0) return 'neige';
      if (c.indexOf('rain') >= 0) return 'pluie';
      return '';
    };
    var dir = function (g) { return ['du nord', 'du nord-est', 'de l’est', 'du sud-est', 'du sud', 'du sud-ouest', 'de l’ouest', 'du nord-ouest'][Math.round(g / 45) % 8]; };
    fetch('https://api.met.no/weatherapi/locationforecast/2.0/compact?lat=40.76&lon=14.02')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var t = d.properties.timeseries[0].data, x = t.instant.details;
        var cielo = desc(((t.next_1_hours || t.next_6_hours || {}).summary || {}).symbol_code);
        var el = document.getElementById('meteo');
        el.innerHTML = '<span class="m-t">' + Math.round(x.air_temperature) + '°</span><span class="m-d"><b>Procida, maintenant</b>' + (cielo ? cielo + ' · ' : '') + 'vent ' + Math.round(x.wind_speed * 3.6) + ' km/h ' + dir(x.wind_from_direction) + '<small>Données météo : MET Norway, <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a></small></span>';
        el.hidden = false;
      }).catch(function () {});
  })();

  // DEMO: il messaggio di uscita si mostra qui; gli altri pulsanti dicono cosa farebbero nella guida vera
  (function () {
    var u = document.getElementById('uscita'), box = document.createElement('div'), toast = document.createElement('div'), t;
    box.id = 'esito'; u.parentNode.insertBefore(box, u.nextSibling);
    toast.className = 'toast'; (document.querySelector('.sd') || document.body).appendChild(toast);
    u.addEventListener('click', function (e) {
      e.preventDefault();
      box.textContent = 'Dans le vrai livret, ce message s’ouvre déjà écrit dans WhatsApp, prêt à envoyer à l’hôte :\n\n' + (u.dataset.testo || '');
      box.classList.add('on');
    });
    document.querySelectorAll('[data-demo]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        toast.textContent = 'Dans le vrai livret, ce bouton ouvre le lien du logement : WhatsApp, carte, téléphone ou page.';
        toast.classList.add('on'); clearTimeout(t); t = setTimeout(function () { toast.classList.remove('on'); }, 2600);
      });
    });
  })();
